export const REVIEW_PRESENCE_CHANNEL_PREFIX = 'brands';

export const REVIEW_PRESENCE_HEARTBEAT_MS = 10_000;

export const REVIEW_PRESENCE_LOCK_TTL_MS = 15_000;

export const REVIEW_PRESENCE_SWEEPER_MS = 5000;
